import { hydrating } from '../hydration.js';

/**
 *
 *
 *
 */
export function set_svg_class(dom, value) {
	/*                                                            */
	var prev_class_name = dom.__className;
	var next_class_name = to_class(value);

	if (hydrating && dom.getAttribute('class') === next_class_name) {
		/*                                                                  */
		/*                                                            */
		dom.__className = next_class_name;
	} else if (
		prev_class_name !== next_class_name ||
		(hydrating && dom.getAttribute('class') !== next_class_name)
	) {
		if (next_class_name === '') {
			dom.removeAttribute('class');
		} else {
			dom.setAttribute('class', next_class_name);
		}

		/*                                                            */
		dom.__className = next_class_name;
	}
}

/**
 *
 *
 *
 */
export function set_mathml_class(dom, value) {
	/*                                                            */
	var prev_class_name = dom.__className;
	var next_class_name = to_class(value);

	if (hydrating && dom.getAttribute('class') === next_class_name) {
		/*                                                                  */
		/*                                                            */
		dom.__className = next_class_name;
	} else if (
		prev_class_name !== next_class_name ||
		(hydrating && dom.getAttribute('class') !== next_class_name)
	) {
		if (next_class_name === '') {
			dom.removeAttribute('class');
		} else {
			dom.setAttribute('class', next_class_name);
		}

		/*                                                            */
		dom.__className = next_class_name;
	}
}

/**
 *
 *
 *
 */
export function set_class(dom, value) {
	/*                                                            */
	var prev_class_name = dom.__className;
	var next_class_name = to_class(value);

	if (hydrating && dom.className === next_class_name) {
		/*                                                                  */
		/*                                                            */
		dom.__className = next_class_name;
	} else if (
		prev_class_name !== next_class_name ||
		(hydrating && dom.className !== next_class_name)
	) {
		/*                                                                   */
		/*                                                                   */
		/*                                                           */
		if (value == null) {
			dom.removeAttribute('class');
		} else {
			dom.className = next_class_name;
		}

		/*                                                            */
		dom.__className = next_class_name;
	}
}

/**
 *
 *
 *
 */
function to_class(value) {
	return value == null ? '' : value;
}

/**
 *
 *
 *
 *
 */
export function toggle_class(dom, class_name, value) {
	if (value) {
		if (dom.classList.contains(class_name)) return;
		dom.classList.add(class_name);
	} else {
		if (!dom.classList.contains(class_name)) return;
		dom.classList.remove(class_name);
	}
}
